import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OccEndpointsService } from '@spartacus/core';
import { OCC_ENDPOINTS, OccWishlistResponse, WishlistEntry } from '@wishlist/const';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OccWishlistService {
  constructor(
    private readonly occEndpointsService: OccEndpointsService,
    private readonly http: HttpClient,
  ) {}

  getEntries(): Observable<WishlistEntry[]> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.wishlistAll);

    return this.http
      .get<OccWishlistResponse>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.wishlistAll),
      })
      .pipe(map((response) => response.entries));
  }

  addEntry({ productCode }: WishlistEntry): Observable<void> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.wishlist, {
      urlParams: { productCode },
    });

    return this.http
      .post(url, null, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.wishlist),
      })
      .pipe(map(() => undefined));
  }

  removeEntry({ productCode }: WishlistEntry): Observable<void> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.wishlist, {
      urlParams: { productCode },
    });

    return this.http
      .delete(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.wishlist),
      })
      .pipe(map(() => undefined));
  }
}
